<template>
  <!--手机端-->
  <div class="news-mobile" v-if="isMobile">
    <div class="img-bg posRelative" @contextmenu.prevent="disableContextMenu">
      <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/banner_xwzx.png" class="posAbsoluteAll"
           draggable="false">
      <div class="banner-text colorfff">
        <div class="font-size60 font-bold">新闻中心</div>
        <div class="line1 margin-top30 margin-bottom30"></div>
        <div class="font-size30">NEWS CENTER</div>
      </div>
    </div>

    <div class="main-content" :class="{'mainAdd': showDetail == true}">
      <!-- 列表 -->
      <div v-show="!showDetail">
        <div class="margin-top50 mLR30">
          <div class="item-news row-me" v-for="(item, index) in newsArray" :key="index" @mouseenter="mouseenter(index)"
               @mouseleave="mouseleave" @click="clickItem(item,index)">
            <img :src="item.img" class="img-item" draggable="false">
            <div class="column-me flex1 margin-left20">
              <div class="font-size20 color666">{{ item.date }}</div>
              <div class="font-size20 lineH30 font-bold color000 mTB15 line1" :class="{'colorRed':nowIndex===index}"
                   v-if="language==='0'">
                {{ item.title }}
              </div>
              <div class="font-size20 lineH30 font-bold color000 mTB15 line1" :class="{'colorRed':nowIndex===index}"
                   v-if="language==='1'">
                {{ item.title_en }}
              </div>
              <div class="font-size18 lineH30 color666 line2" v-if="language==='0'">{{ item.contents }}</div>
              <div class="font-size18 lineH30 color666 line2" v-if="language==='1'">{{ item.contents_en }}</div>
            </div>
          </div>
          <div class="row-me center-all margin-top50 margin-bottom50">
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="pageNo"
                           layout="prev, pager, next" :total="total" background>
            </el-pagination>
          </div>
        </div>
      </div>
      <!-- 新闻详情 -->
      <div v-if="showDetail">
        <div class="tab-div row-me row-center">
          <div class="margin-left25">
            <el-breadcrumb separator=">">
              <el-breadcrumb-item :to="{ path: '/home' }">
                {{ language === '0' ? '首页' : 'Homepage' }}
              </el-breadcrumb-item>
              <el-breadcrumb-item>
						<span class="pointer" @click="clickNews">
							{{ language === '0' ? '新闻中心' : 'News information' }}</span>
              </el-breadcrumb-item>
              <el-breadcrumb-item>
						<span style="color: #0B0F0F;font-weight: bold;"
                  v-if="language==='0'">{{ selectItem.title }}</span>
                <span style="color: #0B0F0F;font-weight: bold;"
                      v-if="language==='1'">{{ selectItem.title_en }}</span>
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </div>
        <div class="margin-left30 margin-right30">
          <div>
            <div class="font-size40 font-bold margin-top50" v-if="language==='0'">{{ selectItem.title }}</div>
            <div class="font-size40 font-bold margin-top50" v-if="language==='1'">{{ selectItem.title_en }}</div>
            <div class="color999 margin-top20" v-if="language==='0'">
              发布者：{{ selectItem.author }}&emsp;&emsp;发布时间：{{ selectItem.date }}
            </div>
            <div class="color999 margin-top20" v-if="language==='1'">
              publisher：{{ selectItem.author_en }}&emsp;&emsp;release time：{{ selectItem.date }}
            </div>
          </div>
          <div class="font-size26 lineH50 color000 margin-top50" v-html="selectItem.contents"
               v-if="language==='0'"></div>
          <div class="font-size26 lineH50 color000 margin-top50" v-html="selectItem.contents_en"
               v-if="language==='1'"></div>
          <div class="row-me margin-top50 bgcF4F4F4 padding30">
            <div class="flex1 font-size20 color000" v-if="upForm">
              <div class="font-bold" v-if="language==='0'">上一篇：</div>
              <div class="font-bold" v-if="language==='1'">Previous：</div>
              <div class="next-text font-size24 pointer" v-if="language==='0'" @click="clickChangeLeft">{{
                  upForm.title
                }}
              </div>
              <div class="next-text font-size24 pointer" v-if="language==='1'" @click="clickChangeLeft">
                {{ upForm.title_en }}
              </div>
            </div>
            <div class="line-grey-shu height100 mLR30" v-if="upForm&&nextForm"></div>
            <div class="flex1 font-size20 color000" v-if="nextForm">
              <div class="font-bold" v-if="language==='0'">下一篇：</div>
              <div class="font-bold" v-if="language==='1'">Next：</div>
              <div class="next-text font-size24 pointer" v-if="language==='0'" @click="clickChangeRight">
                {{ nextForm.title }}
              </div>
              <div class="next-text font-size24 pointer" v-if="language==='1'" @click="clickChangeRight">{{
                  nextForm.title_en
                }}
              </div>
            </div>
          </div>
          <div class="margin-top100"></div>
        </div>
      </div>
    </div>
  </div>

  <!--电脑端-->
  <div class="news" v-else>
    <div class="img-bg posRelative" @contextmenu.prevent="disableContextMenu">
      <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/banner_xwzx.png" class="posAbsoluteAll"
           draggable="false">
      <div class="banner-text colorfff">
        <div class="font-size60 font-bold">新闻中心</div>
        <div class="line1 margin-top30 margin-bottom30"></div>
        <div class="font-size30">NEWS CENTER</div>
      </div>
    </div>

    <div class="main-content" :class="{'mainAdd': showDetail == true}">
      <!-- 列表 -->
      <div v-show="!showDetail">
        <div class="margin-left200 margin-right200 margin-top100">
          <div class="item-news row-me" v-for="(item, index) in newsArray" :key="index" @mouseenter="mouseenter(index)"
               @mouseleave="mouseleave" @click="clickItem(item,index)">
            <img :src="item.img" class="img-item" draggable="false">
            <div class="column-me flex1 margin-top50 margin-right50">
              <div class="font-size18 color666">{{ item.date }}</div>
              <div class="font-size24 lineH40 font-bold color000 mTB20 line2" :class="{'colorRed':nowIndex===index}"
                   v-if="language==='0'">
                {{ item.title }}
              </div>
              <div class="font-size24 lineH40 font-bold color000 mTB20 line2" :class="{'colorRed':nowIndex===index}"
                   v-if="language==='1'">
                {{ item.title_en }}
              </div>
              <div class="font-size18 lineH30 color666 line2" v-if="language==='0'">{{ item.contents }}</div>
              <div class="font-size18 lineH30 color666 line2" v-if="language==='1'">{{ item.contents_en }}</div>
              <div class="flex1"></div>
              <div class="row-me row-center flex-end1 margin-top15 margin-bottom20">
                <div class="row-me center-all look-div" :class="{'look-div-active':nowIndex===index}">
                  <span v-if="language==='0'">查看详情</span>
                  <span v-if="language==='1'">Discover More</span>
                  <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/zk2.png"
                       class="img20 objScaleDown margin-left10" draggable="false"
                       v-if="nowIndex===index">
                  <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/zk1.png"
                       class="img20 objScaleDown margin-left10" draggable="false" v-else>
                </div>
              </div>
            </div>
          </div>
          <div class="row-me center-all margin-top100 margin-bottom100">
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="pageNo"
                           layout="prev, pager, next" :total="total" background>
            </el-pagination>
          </div>
        </div>
      </div>
      <!-- 新闻详情 -->
      <div v-if="showDetail">
        <div class="tab-div row-me row-center">
          <div class="margin-left200">
            <el-breadcrumb separator=">">
              <el-breadcrumb-item :to="{ path: '/home' }">
                {{ language === '0' ? '首页' : 'Homepage' }}
              </el-breadcrumb-item>
              <el-breadcrumb-item>
						<span class="pointer" @click="clickNews">
							{{ language === '0' ? '新闻中心' : 'News information' }}</span>
              </el-breadcrumb-item>
              <el-breadcrumb-item>
						<span style="color: #0B0F0F;font-weight: bold;"
                  v-if="language==='0'">{{ selectItem.title }}</span>
                <span style="color: #0B0F0F;font-weight: bold;"
                      v-if="language==='1'">{{ selectItem.title_en }}</span>
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </div>
        <div class="margin-left200 margin-right200">
          <div class="column-me row-center">
            <div class="font-size30 font-bold margin-top100" v-if="language==='0'">{{ selectItem.title }}</div>
            <div class="font-size30 font-bold margin-top100" v-if="language==='1'">{{ selectItem.title_en }}</div>
            <div class="font-size18 color999 margin-top20" v-if="language==='0'">
              发布者：{{ selectItem.author }}&emsp;&emsp;发布时间：{{ selectItem.date }}
            </div>
            <div class="font-size18 color999 margin-top20" v-if="language==='1'">
              publisher：{{ selectItem.author_en }}&emsp;&emsp;release time：{{ selectItem.date }}
            </div>
          </div>
          <div class="font-size20 lineH30 color000 margin-top60" v-html="selectItem.contents"
               v-if="language==='0'"></div>
          <div class="font-size20 lineH30 color000 margin-top60" v-html="selectItem.contents_en"
               v-if="language==='1'"></div>
          <div class="line-grey-heng margin-top60"></div>
          <div class="row-me row-center margin-top50 font-size18 color000" v-if="upForm">
            <span class="font-bold" v-if="language==='0'">上一篇：</span>
            <span class="font-bold" v-if="language==='1'">Previous：</span>
            <sapn class="next-text pointer" v-if="language==='0'" @click="clickChangeLeft">{{ upForm.title }}</sapn>
            <sapn class="next-text pointer" v-if="language==='1'" @click="clickChangeLeft">{{ upForm.title_en }}</sapn>
          </div>
          <div class="row-me row-center margin-top30 font-size18 color000" v-if="nextForm">
            <span class="font-bold" v-if="language==='0'">下一篇：</span>
            <span class="font-bold" v-if="language==='1'">Next：</span>
            <sapn class="next-text pointer" v-if="language==='0'" @click="clickChangeRight">{{ nextForm.title }}</sapn>
            <sapn class="next-text pointer" v-if="language==='1'" @click="clickChangeRight">{{
                nextForm.title_en
              }}
            </sapn>
          </div>
          <div class="margin-top100"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      newsArray: [],
      pageNo: 1,
      total: 0,
      showDetail: false, //显示详情页
      selectItem: {},
      selectId: '',
      selectIndex: -1, //点击的下标，详情切换用
      language: '', //0中文，1英文
      isMobile: '', //0电脑，1手机
      isMuted: true, //视频是否静音
      tabIndex: 1,
      upForm: null, //上一篇
      nextForm: null, //下一篇
      hoverIndex: null,
      nowIndex: -1,
    }
  },
  watch: {
    navItem: {
      handler: function (newVal, oldVal) {
        if (newVal.link_url === '/news') {
          this.pageNo = 1
          this.getData()
          this.selectId = this.$route.query.id
          if (this.selectId !== null && this.selectId !== undefined) {
            this.getDetail()
          }
        }
      }
    },
    $route: {
      handler(to, from) {
        if (to.query.id === null || to.query.id === undefined) {
          this.showDetail = false
        } else {
          this.showDetail = true
        }
      },
      // 深度观察监听
      deep: true
    }
  },
  computed: {
    navItem() {
      return this.$store.state.navItem;
    },
  },
  created() {
    this.isMobile = sessionStorage.getItem("mobile") === '1'
    this.language = sessionStorage.getItem("language")
    document.title = this.navItem.name
    this.pageNo = 1
    this.getData()
    this.selectId = this.$route.query.id
  },
  activated() {
    this.language = sessionStorage.getItem("language")
    document.title = this.navItem.name
  },
  mounted() {

  },
  methods: {
    disableContextMenu(event) {
      event.preventDefault();
    },
    mouseenter(index) {
      this.nowIndex = index
    },
    mouseleave() {
      this.nowIndex = -1
    },
    // 点击联系我们
    onClick() {
      this.$router.push({
        path: '/contact'
      })
      const element = document.querySelector('.mobile-title');
      if (this.language == 0) {
        element.innerHTML = '联系我们';
      } else {
        element.innerHTML = 'Contact us';
      }
    },
    setHoverIndex(index) {
      this.hoverIndex = index;
    },
    clearHoverIndex() {
      this.hoverIndex = null;
    },
    // 点击新闻中心
    tabClick(index) {
      this.tabIndex = index;
      this.pageNo = 1
      this.getData()
    },
    clickNews() {
      this.selectIndex = -1
      this.selectId = ''
      this.$router.push({
        path: '/news'
      })
      this.showDetail = false
      this.getData()
    },
    clickItem(item, index) {
      this.selectId = item.id
      this.selectIndex = index
      this.$router.push({
        path: '/news',
        query: {
          id: this.selectId
        }
      })
      this.getDetail()
    },
    clickChangeLeft() {
      this.selectIndex--
      this.selectId = this.newsArray[this.selectIndex].id
      if (this.selectId !== null && this.selectId !== undefined) {
        this.getDetail()
      }
    },
    clickChangeRight() {
      this.selectIndex++
      this.selectId = this.newsArray[this.selectIndex].id
      if (this.selectId !== null && this.selectId !== undefined) {
        this.getDetail()
      }
    },
    //页数改变
    handleCurrentChange(pageNo) {
      this.pageNo = pageNo
      this.getData()
      this.$bus.$emit('scrollTo', 650)
    },
    //获取数据
    getData() {
      this.$getRequest("/api/newsList", {
        page: this.pageNo,
        rows: 10,
      }).then((res) => {
        if (res) {
          this.total = res.data.total;
          res.data.data.forEach((item, index) => {
            item.contents = item.contents.replace(/&nbsp;/g, '');
            item.contents = item.contents.replace(/&mdash;/g, '');
            item.contents = item.contents.replace(/\s/g, '');
            item.contents_en = item.contents_en.replace(/&nbsp;/g, '');
            item.contents_en = item.contents_en.replace(/&mdash;/g, '');
            item.contents_en = item.contents_en.replace(/\s/g, '');
            item.date = item.created_at.split(" ")[0]
          });
          this.newsArray = res.data.data;
          if (this.selectId !== null && this.selectId !== undefined) {
            for (let i = 0; i < this.newsArray.length; i++) {
              if (this.selectId == this.newsArray[i].id) {
                this.selectIndex = i
              }
            }
          }
          if (!this.$method.isEmpty(this.selectId)) {
            this.getDetail()
          }
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    getDetail() {
      this.$getRequest('/api/newsInfo', {
        id: this.selectId
      }).then((res) => {
        if (res) {
          res.data.date = res.data.created_at.split(" ")[0]
          if (this.isMobile) {
            res.data.contents = this.$method.formatRichText(res.data.contents)
            res.data.contents_en = this.$method.formatRichText(res.data.contents_en)
          }
          this.selectItem = res.data
          this.showDetail = true
          this.$bus.$emit('scrollTo', 650)
          if (this.selectIndex > 0) {
            this.upForm = this.newsArray[this.selectIndex - 1]; //上一篇
          } else {
            this.upForm = null
          }
          if (this.selectIndex < this.newsArray.length - 1) {
            this.nextForm = this.newsArray[this.selectIndex + 1]; //下一篇
          } else {
            this.nextForm = null
          }
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.news-mobile {
  .img-bg {
    width: 100%;
    height: 560px;

    .banner-text {
      position: absolute;
      left: 30px;
      top: 336px;

      .line1 {
        width: 54px;
        height: 8px;
        background: #FFFFFF;
      }
    }
  }

  .mainAdd {
    background-color: #fff;
  }

  .main-content {
    .item-news {
      margin-bottom: 40px;
      cursor: pointer;

      &:hover {
        box-shadow: 0px 10px 50px rgba(0, 0, 0, 0.2);
      }

      .img-item {
        width: 262px;
        height: 150px;
        object-fit: cover;
      }
    }
  }

  .tab-div {
    width: 100%;
    height: 80px;
    border-bottom: 1px solid #ECECEC;
  }

  .next-text {
    color: #000000;
    margin-top: 20px;
  }
}

.news {
  .img-bg {
    width: 100%;
    height: 750px;

    .banner-text {
      position: absolute;
      left: 200px;
      top: 370px;

      .line1 {
        width: 54px;
        height: 8px;
        background: #FFFFFF;
      }
    }
  }

  .mainAdd {
    background-color: #fff;
  }

  .main-content {
    .item-news {
      margin-bottom: 40px;
      cursor: pointer;

      &:hover {
        box-shadow: 0px 10px 50px rgba(0, 0, 0, 0.2);
      }

      .img-item {
        width: 374px;
        height: 214px;
        object-fit: cover;
        margin: 50px;
      }

      .look-div {
        padding: 0 15px;
        line-height: 40px;
        text-align: center;
        border-radius: 20px;
        border: 1px solid #BFBFBF;
        font-size: 16px;
        color: #666666;

        &-active {
          background: #D60110;
          color: #FFFFFF;
          border: 1px solid #D60110;
        }
      }
    }
  }

  .tab-div {
    width: 100%;
    height: 80px;
    background: #F4F4F4;
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.1);
    border-radius: 0px;
  }

  .next-text {
    color: #000000;

    &:hover {
      color: #D60110;
    }
  }
}
</style>
